import { Map } from 'immutable';

import {
    SET_SESSION_TYPE,
    SET_SESSION_DATA,
    CLEAR_SESSION_DATA,
    SET_SESSION_STATUS,
    SET_SESSION_VIDEO_STATUS,
    SET_LESSON_SETTINGS,
    SET_LESSON_DELIVERY_ID,
    SET_LESSON_JOIN_CODE,
} from './actions';

export const SESSION_KEY = 'sessionId';

const emptySessionData = Map();

export function sessionReducer(state = emptySessionData, action) {
    switch (action.type) {
        case SET_SESSION_TYPE:
            return state.set('sessionType', action.sessionType);
        case SET_SESSION_DATA:
            return state.merge(
                Map([
                    ['sessionId', action.sessionId],
                    ['sessionType', action.sessionType],
                ]),
            );
        case CLEAR_SESSION_DATA:
            return emptySessionData;
        case SET_SESSION_STATUS:
            return state.set('sessionStatus', action.sessionStatus);
        case SET_LESSON_SETTINGS:
            return state.set('lessonSettings', action.settings);
        case SET_SESSION_VIDEO_STATUS:
            return state.set('sessionVideoStatus', action.videoStatus);
        case SET_LESSON_DELIVERY_ID:
            return state.set('lessonDeliveryId', action.lessonDeliveryId);
        case SET_LESSON_JOIN_CODE:
            return state.set('lessonJoinCode', action.lessonJoinCode);
    }
    return state;
}
